import { useNavigation } from "@react-navigation/native";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  BackHandler,
  StyleSheet,
  Text,
  TouchableNativeFeedback,
  View,
} from "react-native";
import { useSelector } from "react-redux";
import BackArrow from "@assets/svg/BackArrow";
import colors from "@constants/color";
// Events
import { getRvpOrderDetails } from "@services/api";
import { scale } from "../../utils/scale";
import OrderItemForRefundReplace from "./RefundAndReplace/OrderItemForRefundReplaceV2";

const SelectProduct = ({ route }) => {
  const { params = {} } = route;
  const { goBackScreenName = "", rvpData: rvpDataFromParams = {} } = params;

  const scrollViewRef = useRef();
  const navigation = useNavigation();
  const [rvpData, setRvpResponse] = useState(rvpDataFromParams);
  const { selectedOrder = null } = useSelector((s) => s.orders);

  const scrollToBottom = () => {
    scrollViewRef.current.scrollToEnd({ animated: true });
  };

  const backHandler = useCallback(() => {
    if (goBackScreenName) {
      navigation.replace(goBackScreenName);
    } else {
      navigation.goBack();
    }
    return true;
  }, [navigation, goBackScreenName]);

  useEffect(() => {
    const backHandlerSub = BackHandler.addEventListener("hardwareBackPress", backHandler);
    return () => {
      backHandlerSub.remove();
    };
  }, [backHandler]);

  // TODO : remove this in future if not using
  // getRvpOrderDetailsFromApi this is not getting called in current scenario
  const getRvpOrderDetailsFromApi = async () => {
    const { data: rvpResponse } = await getRvpOrderDetails(selectedOrder);
    const rvpDataFilter = rvpResponse.items?.filter(
      (rvp) => rvp.parent_order == selectedOrder,
    );
    Array.isArray(rvpDataFilter) &&
      rvpDataFilter.length &&
      setRvpResponse(rvpDataFilter[0]);
  };

  useEffect(() => {
    if (!rvpData) {
      getRvpOrderDetailsFromApi();
    }
  }, []);

  return (
    <>
      <View style={[styles.header, {}]}>
        <TouchableNativeFeedback
          testID="back"
          style={{ paddingRight: 15, paddingVertical: 10, marginLeft: 10 }}
          onPress={backHandler}
        >
          <BackArrow style={{ margin: 20 }} />
        </TouchableNativeFeedback>
        <Text
          fontType="head2"
          style={{
            color: colors.mediumBlack,
            fontWeight: "bold",
            alignSelf: "center",
            fontSize: scale(20),
            marginRight: "auto",
          }}
          bold
        >
          रिटर्न
        </Text>
      </View>
      <View>
        <OrderItemForRefundReplace
          rvpData={rvpData}
          scrollToBottom={scrollToBottom}
          navigation={navigation}
        />
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  header: {
    backgroundColor: "white",
    // paddingHorizontal: 10,
    flexDirection: "row",
    minHeight: 56,
    elevation: 1,
    alignItems: "center",
  },
});

export default SelectProduct;
